import { createStore, combineReducers } from "lib/store/v2";
import { createStoreLogger } from "utils/createStoreLogger";
import { WorkActions as Work } from "./Work";

const reducers = { Work };

const reducer = combineReducers(reducers, createStoreLogger("Work"));

export const {
  StoreProvider: WorkStoreProvider,
  useStore: useWorkStore,
  useSelector: useWorkSelector,
  useDispatch: useWorkDispatch
} = createStore(reducer);
